import * as Api from "@/api/invitation";
import { appendCss } from "@/utils/invitationUtil";

const state = {
  isLoad: false,
  fonts: [],
  music: {},
  pages: [],
  step_icon: ""
};

const mutations = {
  SET_INVITATION(state, payload = {}) {
    Object.assign(state, payload);
  }
};

const actions = {
  async fetchInvitation({ commit }, params) {
    const data = await Api.detail(params);
    const { cover, fonts = [], music = {}, pages = [], step_icon = "" } = data;
    commit("SET_INVITATION", {
      cover,
      fonts,
      music,
      pages,
      step_icon,
      isLoad: true
    });
    fonts.forEach(font => {
      appendCss(font);
    });
    return data;
  }
};

export default {
  state,
  mutations,
  actions
};
